var _defs, _g, _g2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCentralHeatingOtherOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Composant_71",
    "data-name": "Composant 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42.451,
    height: 60,
    viewBox: "0 0 42.451 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.855,
    y1: -0.094,
    x2: 0.094,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f06f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#698ed3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heater",
    transform: "translate(-3.949 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M39.529,47.881V46.4H37.5s-.009,1.053,0,1.48a3.316,3.316,0,0,1-3.444,3.456A3.46,3.46,0,0,1,30.6,47.881V46.4H28.63v1.48a3.456,3.456,0,1,1-6.911,0V46.4H19.745v1.48a3.46,3.46,0,0,1-3.455,3.456c-1.691-.051-3.428-.756-3.494-3.456.023-.867,0-1.48,0-1.48H10.9v1.48A3.265,3.265,0,0,1,7.4,51.337a3.46,3.46,0,0,1-3.455-3.456V3.455a3.455,3.455,0,1,1,6.91,0V4.937h1.975V3.455a3.456,3.456,0,0,1,6.911,0V4.937h1.974V3.455a3.456,3.456,0,0,1,6.911,0V4.937H30.6V3.455a3.456,3.456,0,0,1,6.911,0V4.937H39.49V3.455a3.455,3.455,0,0,1,6.91,0l-.049,44.92a3.452,3.452,0,0,1-3.407,2.962A3.278,3.278,0,0,1,39.529,47.881Z",
    transform: "translate(0 0)",
    fill: "rgba(129,139,142,0.23)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2701",
    "data-name": "Rectangle 2701",
    transform: "translate(5.051 10.537)",
    fill: "#fff",
    stroke: "#3a484d",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 31,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 32,
    height: 30,
    rx: 1.5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M30.349,17.318H0V15.294H30.349a.921.921,0,0,0,0-1.842h-18.3a3.025,3.025,0,0,1,0-6.049H30.034a1.239,1.239,0,0,0,0-2.477H12.111a3.088,3.088,0,0,1,0-6.176H42.1V.774H12.111a1.064,1.064,0,0,0,0,2.128H30.034a3.263,3.263,0,0,1,0,6.525H12.048a1,1,0,0,0,0,2h18.3a2.945,2.945,0,0,1,0,5.89Z",
    transform: "translate(0 17.634)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Union_28",
    "data-name": "Union 28",
    d: "M-1701.5,2958a1.5,1.5,0,0,1-1.5-1.5v-12a1.5,1.5,0,0,1,1.5-1.5,1.5,1.5,0,0,1,1.5,1.5V2955h31v3Z",
    transform: "translate(1711.051 -2898)",
    fill: "#e2e4e5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentralHeatingOtherOff);
export default __webpack_public_path__ + "static/media/central-heating-other-off.ba551c9518fe771d98d29a33b53177ad.svg";
export { ForwardRef as ReactComponent };